import {  useEffect, useState } from 'react';
import StatisticsStyle from "../styles&pics/StatisticsStyle";
import GetStatistics from "./GetStatistics";
import TypingText from "../UtilityComponents/TypingText";
import PercChart from './PercChart';

const Statistics = () => {
  const [storedUser, setStoredUser] = useState(null);
  const [sectionIndex, setSectionIndex] = useState(0);

  useEffect(() => {
    const logged = localStorage.getItem('loggedInUser');
    setStoredUser(logged);
  }, []);

  const serverData = GetStatistics({ user: storedUser });
      
  useEffect(() => {
    if (serverData !== null && sectionIndex === 0) {
      const timer = setTimeout(() => {}, 3500);
      return () => clearTimeout(timer);
    }
  }, [serverData, sectionIndex]);

  const renderNextSection = () => {
    setSectionIndex(prevIndex => prevIndex + 1);
  };

  let sections = [];
  if (serverData !== null) {
    sections = [
      {
        component: (
          <div className='loadedstats'>
            <TypingText text={"Έγινε φόρτωση των στατιστικών!"} /> 
          </div>
        ),
        shouldRender: true
      },
      {
        component: (
          <div className='stat-item user'>
            <TypingText text={"Χρήστης: " + storedUser} />
          </div>
        ),
        shouldRender: true
      },
      {
        component: (
          <div className='stat-item totalexams'>
            <TypingText text={"Καταχωρημένες εξετάσεις: " + serverData.totalExams} />
          </div>
        ),
        shouldRender: true
      },
      {
        component: (
          <div className='stat-item latestdate'>
            <TypingText text={"Τελευταία εξέταση στις: " + (serverData.latestDate ? serverData.latestDate : "-")} />
          </div>
        ),
        shouldRender: true
      },
      {
        component: (
          serverData.totalExams > 0 ? (
            <div className='stat-item average'>
              <TypingText text={"Μέσος όρος βαθμολογίας: " + serverData.averageScore.toFixed(2)} />
            </div>
          ) : null
        ),
        shouldRender: serverData.totalExams > 0
      },
      {
        component: (
          serverData.totalExams > 0 ? (
            <div className='stat-item successperc'>
              <TypingText text={"Ποσοστό επιτυχίας:"} /> 
            </div>
          ) : null
        ),
        shouldRender: serverData.totalExams > 0
      },
      {
        component: (
          serverData.totalExams > 0 ? (
            <div className='chart-container'>
              <PercChart percentage={serverData.successPerc.toFixed(2)} />
            </div>
          ) : null
        ),
        shouldRender: serverData.totalExams > 0
      },
      {
        component: (
          serverData.totalExams > 0 ? (
            <div className='stat-section-title scorestitle'>
              <TypingText text={"ΒΑΘΜΟΛΟΓΙΕΣ ΑΠΑΝΤΗΣΕΩΝ:"} />
            </div>
          ) : null
        ),
        shouldRender: serverData.totalExams > 0 
      },
      {
        component: (
          serverData.totalExams > 0 ? (
            <div className='stat-category-title eidikes_title'>
              <TypingText text={"ΕΙΔΙΚΕΣ:"} />
            </div>
          ) : null
        ),
        shouldRender: serverData.totalExams > 0
      },
      {
        component: (
          serverData.totalExams > 0 ? (
            <div className='stat-list eidikes'>
              <ul>
                {Object.keys(serverData.questionAverages.eidikes).map(questionId => (
                  <li key={questionId}>
                    <TypingText text={"Ερώτηση: " + questionId + " | Ποσοστό επιτυχίας: " + (serverData.questionAverages.eidikes[questionId].toFixed(2) * 100) + "% | Απαντήθηκε " + serverData.questionCounts.eidikes[questionId] + (serverData.questionCounts.eidikes[questionId] === 1 ? " φορά" : " φορές")} />
                  </li>
                ))}
              </ul>
            </div>
          ) : null
        ),
        shouldRender: serverData.totalExams > 0
      },
      {
        component: (
          serverData.totalExams > 0 ? (
            <div className='stat-category-title vasikes_title'>
              <TypingText text={"ΒΑΣΙΚΕΣ:"} />
            </div>
          ) : null
        ), 
        shouldRender: serverData.totalExams > 0
      },
      {
        component: (  
          serverData.totalExams > 0 ? (
            <div className='stat-list vasikes'>
              <ul>
                {Object.keys(serverData.questionAverages.vasikes).map(questionId => (
                  <li key={questionId}>
                    <TypingText text={"Ερώτηση: " + questionId + " | Ποσοστό επιτυχίας: " + (serverData.questionAverages.vasikes[questionId].toFixed(2) * 100) + "% | Απαντήθηκε " + serverData.questionCounts.vasikes[questionId] + (serverData.questionCounts.vasikes[questionId] === 1 ? " φορά" : " φορές")} />
                  </li> 
                ))}
              </ul>
            </div>
          ) : null
        ),
        shouldRender: serverData.totalExams > 0
      }
    ];
  }

  useEffect(() => {
    if (serverData === null || sections.length === 0) return;
    
    const timer = setInterval(() => {
      if (sectionIndex < sections.length - 1) {
        renderNextSection();
      } else {
        clearInterval(timer);
      }
    }, 2500);

    return () => clearInterval(timer);
  }, [sectionIndex, serverData]);

  return (
    serverData !== null ? (
      <>
        <StatisticsStyle />
        <main className="statistics-main">
          <div className="statistics-container">
            <div className="statistics-header">
              <h2>Στατιστικά</h2>
            </div>
            <div className='statistics-card'>
              {sections.map((section, index) => (
                section.shouldRender && sectionIndex >= index && (
                  <div key={index} className="stat-section">
                    {section.component}
                  </div>
                )
              ))}
            </div>
          </div>
        </main>
      </>
    ) : (
      <>
        <StatisticsStyle />
        <main className="statistics-main">
          <div className="loading-container">
            <span className="statsloader"></span>
          </div>
        </main>
      </>
    )
  );
};

export default Statistics;
